import { gsap, ScrollTrigger, isMeasurable } from "./gsapSetup";

export function prepareBackgroundPositionAnim() {
  const leftBg = document.querySelector(".gs-bg-left");
  const rightBg = document.querySelector(".gs-bg-right");
  if (!leftBg || !rightBg) return;

  gsap.set(leftBg, { backgroundPosition: "-40% 50%" });
  gsap.set(rightBg, { backgroundPosition: "140% 100%" });
}

export function playBackgroundPositionAnim() {
  const leftBg = document.querySelector(".gs-bg-left");
  const rightBg = document.querySelector(".gs-bg-right");
  if (!leftBg || !rightBg) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  // Wait until after layout is stable (loader removed, fonts applied, etc.)
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      // If elements still aren't measurable, delay creation until they are
      if (!isMeasurable(leftBg) || !isMeasurable(rightBg)) {
        const retry = () => {
          if (isMeasurable(leftBg) && isMeasurable(rightBg)) {
            window.removeEventListener("loader:done", retry);
            create();
          }
        };
        // if you have a loader event, use it; otherwise this just won’t fire
        window.addEventListener("loader:done", retry);
        // also attempt a refresh later
        setTimeout(retry, 300);
        return;
      }

      create();
    });
  });

  function create() {
    // kill old triggers/tweens for safety (prevents duplicates on SPA nav)
    ScrollTrigger.getAll()
      .filter(st => st.trigger === leftBg || st.trigger === rightBg)
      .forEach(st => st.kill());

    gsap.to(leftBg, {
      backgroundPosition: "0% 50%",
      duration: 1.4,
      ease: "power3.out",
      scrollTrigger: {
        trigger: leftBg,
        start: "top 80%",
        once: true,
        invalidateOnRefresh: true,
      },
    });

    gsap.to(rightBg, {
      backgroundPosition: "100% 100%",
      duration: 1.4,
      ease: "power3.out",
      scrollTrigger: {
        trigger: rightBg,
        start: "top 80%",
        once: true,
        invalidateOnRefresh: true,
      },
    });

    // One more refresh after creating triggers (safe timing)
    ScrollTrigger.refresh(true);
  }
}
